import { useOmniboxResultRowContext } from "@mirage/mosaics/Omnibox/context/OmniboxResultRowContext";

import type { typeahead } from "@mirage/service-typeahead-search/service/types";
import {
  BaseRecentsResultRow,
  BaseRecentsResultRowProps,
} from "./BaseRecentsResultRow";

type Props = Pick<
  BaseRecentsResultRowProps<typeahead.ScoredPreviousQuery>,
  "scoredResult" | "isSelected"
>;

export const WithPreviousQueryResultRow = (props: Props) => {
  const { handleRemovePreviousQuery } = useOmniboxResultRowContext();

  return (
    <BaseRecentsResultRow<typeahead.ScoredPreviousQuery>
      {...props}
      title={props.scoredResult.result.query}
      handleRemove={handleRemovePreviousQuery}
    />
  );
};
